import SectionHeading from '@/components/base/SectionHeading';
import Reveal from '@/components/base/Reveal';
import { accent } from '@/components/feature/solution/theme';

interface SceneItem {
  id: string;
  icon: string;
  title: string;
  image: string;
  alt: string;
  deploy: string;
  work: string;
  value: string;
}

interface ParkingScenariosProps {
  data: {
    eyebrow: string;
    title: string;
    subtitle: string;
    items: SceneItem[];
    adaptNote: string;
  };
}

export default function ParkingScenarios({ data }: ParkingScenariosProps) {
  const a = accent('gold');

  return (
    <section id="scenes" className="w-full px-4 md:px-6 py-16 md:py-24 bg-background-50 scroll-mt-20">
      <div className="max-w-[1200px] mx-auto">
        <SectionHeading eyebrow={data.eyebrow} title={data.title} subtitle={data.subtitle} />

        {/* 六大场景卡片 */}
        <div className="mt-12 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {data.items.map((s, idx) => (
            <Reveal key={s.id} delay={idx * 70}>
              <article className="group h-full rounded-2xl overflow-hidden border border-background-200 bg-background-100">
                <div className="relative w-full aspect-[4/5] overflow-hidden">
                  <img
                    src={s.image}
                    alt={s.alt}
                    title={s.alt}
                    className="w-full h-full object-cover object-center transition-transform duration-700 group-hover:scale-[1.06]"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/92 via-foreground-950/30 to-transparent"></div>
                  <div className="absolute inset-x-0 bottom-0 p-5">
                    <div className="flex items-center gap-3">
                      <span
                        className={`w-11 h-11 flex items-center justify-center rounded-xl ${a.solid} text-foreground-950 shrink-0`}
                      >
                        <i className={`${s.icon} text-xl`}></i>
                      </span>
                      <h3 className="font-heading font-bold text-background-50 text-lg md:text-xl">{s.title}</h3>
                    </div>
                    <p className="mt-3 text-xs md:text-sm text-background-200 leading-relaxed">{s.value}</p>
                  </div>
                </div>
              </article>
            </Reveal>
          ))}
        </div>

        <Reveal className="mt-6" delay={100}>
          <div className="flex items-center gap-3 rounded-2xl bg-foreground-950 px-5 py-4">
            <i className="ri-apps-2-line text-secondary-400 text-lg shrink-0"></i>
            <p className="text-xs md:text-sm text-foreground-300 leading-relaxed">{data.adaptNote}</p>
          </div>
        </Reveal>
      </div>
    </section>
  );
}